import React from 'react';

import styles from './HomePage.module.css';

const ConfirmationPage = () => {
  return (
    <div className={styles.app}>
      <div>
        <form className={styles.form} onSubmit={() => {}} noValidate>
          <div className={styles.appHeader}>
            <img src="/images/logo.svg" className={styles.appLogo} alt="logo" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConfirmationPage;
